import { jsxs as L, Fragment as R, jsx as l } from "react/jsx-runtime";
import { forwardRef as T, useRef as O, useState as j, useEffect as A } from "react";
import C from "classnames";
import D from "../builders-icons/dist/systems/close.js";
import { useId as S, useTracking as K, getText as H, onRoleButtonKeyDown as I } from "../utils.js";
import n from "./tooltip.module.less.js";
const P = T(
  function({
    children: e,
    className: c,
    color: a = "blue",
    content: d,
    hover: p = !0,
    id: i,
    // Ensure ID for aria-labelledby
    size: u = "md",
    tracking: f = !0,
    ...w
  }, b) {
    const s = S(), x = S(), g = O(null), k = K(f), [t, o] = j(!1);
    return A(() => {
      if (!g.current)
        return;
      const m = g.current, E = m.previousElementSibling, h = () => N(E), y = ({ key: r }) => r === "Escape" && o(!1), M = ({ target: r }) => {
        t !== "click" && E.contains(r) ? (o("click"), t === !1 && k({
          eventCategory: "tooltip",
          eventAction: "open",
          eventLabel: H(r)
        })) : t && !m.contains(r) && o(!1);
      };
      return document.addEventListener("click", M), t && (N(E), document.addEventListener("keydown", y), window.addEventListener("scroll", h, !0), window.addEventListener("resize", h)), () => {
        document.removeEventListener("click", M), document.removeEventListener("keypress", y), window.removeEventListener("scroll", h, !0), window.removeEventListener("resize", h);
      };
    }, [t, k]), /* @__PURE__ */ L(R, { children: [
      /* @__PURE__ */ l(
        "span",
        {
          ...w,
          "aria-expanded": t === "click",
          "aria-controls": x,
          className: C(n.button, c),
          id: i || s,
          onMouseEnter: ({ target: m }) => {
            !p || t || (o("hover"), k({
              eventCategory: "tooltip",
              eventAction: "open",
              eventLabel: H(m)
            }));
          },
          onMouseLeave: () => t === "click" || o(!1),
          onKeyDown: I,
          tabIndex: 0,
          role: "button",
          ref: b,
          children: e
        }
      ),
      /* @__PURE__ */ L(
        "span",
        {
          "aria-labelledby": i || s,
          className: C(n.tooltip, n[a], n[u]),
          hidden: !t,
          id: x,
          ref: g,
          role: "tooltip",
          children: [
            /* @__PURE__ */ L(
              "svg",
              {
                xmlns: "http://www.w3.org/2000/svg",
                width: "21",
                height: "14",
                fill: "none",
                className: n.arrow,
                children: [
                  /* @__PURE__ */ l(
                    "path",
                    {
                      stroke: "none",
                      d: "M10 1c3.18 3.99 6.83 8.51 10 12.5H0C3.16 9.51 6.84 4.99 10 1Z"
                    }
                  ),
                  /* @__PURE__ */ l(
                    "path",
                    {
                      stroke: "#090C33",
                      strokeLinecap: "round",
                      strokeLinejoin: "round",
                      d: "M19.53 12.5 10.01 1A4971.7 4971.7 0 0 0 .5 12.5"
                    }
                  )
                ]
              }
            ),
            d,
            /* @__PURE__ */ l(
              "span",
              {
                "aria-label": "❌",
                className: n.close,
                hidden: t !== "click",
                onClick: () => o(!1),
                onKeyDown: I,
                role: "button",
                tabIndex: 0,
                children: /* @__PURE__ */ l(D, { width: 16, height: 16 })
              }
            )
          ]
        }
      )
    ] });
  }
);
function N(v) {
  const e = v.nextElementSibling, c = e.firstElementChild;
  e.style.top = e.style.left = "0px";
  const { left: a, width: d, top: p, bottom: i } = v.getClientRects()[0], u = e.clientHeight + c.clientHeight, f = Math.min(
    Math.max(10, a - (e.clientWidth - d) / 2),
    window.innerWidth - e.clientWidth - 10
  ), w = p - u > 0, s = !(i + u < window.innerHeight) && w;
  c.style.left = `${Math.round(a + d / 2 - f)}px`, e.style.left = `${Math.round(f)}px`, e.style.top = `${Math.round(s ? p : i)}px`, e.classList.toggle(n.isOver, s);
}
export {
  P as Tooltip
};
//# sourceMappingURL=tooltip.js.map
